import { useContext } from 'react';

import { SideNavContext } from './SideNavContext.jsx';
import LdsIcon from '../LdsIcon/index.jsx';
import LdsLink from '../LdsLink/index.jsx';

export default function DynamicMenuItemButton({
  menuItem,
  parentId,
  children,
  routerLink,
  isShowingSubMenu,
}) {
  const { setActive } = useContext(SideNavContext);
  const menuItemType = ('link' in menuItem || 'anchor' in menuItem) ? 'link' : 'button';
  const hasSubMenu = 'subMenu' in menuItem || 'jumpMenu' in menuItem;
  const ariaExpanded = hasSubMenu ? (!!isShowingSubMenu) : null;

  const ExternalIcon = ({ showIcon }) => {
    if (!showIcon) return '';

    return (
      <LdsIcon name="ArrowSquareOut" inline decorative style={{ marginLeft: '.25rem' }} />
    );
  };

  if (menuItemType === 'link' && menuItem.link?.externalLabel) {
    return (
      <LdsLink
        className="lds-side-nav-menu-item-content"
        external
        disableAutoIcon
        href={menuItem.link.href}
        aria-label={menuItem.link.ariaLabel}
        target={menuItem.link.target}
      >
        {children}

        <ExternalIcon showIcon={menuItem.link.externalIcon} />
      </LdsLink>
    );
  }

  if (menuItemType === 'link' && menuItem.link?.externalModal) {
    return (
      <button
        className="lds-button-clear-style lds-side-nav-menu-item-content nav-external-btn"
        type="button"
        onClick={() => menuItem.link.externalModal(menuItem.link)}
        aria-label={menuItem.link.ariaLabel}
      >
        {children}

        <ExternalIcon showIcon={menuItem.link.externalIcon} />
      </button>
    );
  }

  if (menuItemType === 'link') {
    return routerLink(
      {
        className: 'lds-side-nav-menu-item-content',
        onClick: () => setActive(menuItem.id),
        to: menuItem.link.to,
        href: menuItem.link.href,
        role: hasSubMenu ? 'button' : null,
        'aria-expanded': ariaExpanded,
      },
      <>{children}</>
    );
  }

  return (
    <button
      className="lds-button-clear-style lds-side-nav-menu-item-content"
      onClick={() => setActive(menuItem.id, parentId)}
      type="button"
      role={hasSubMenu ? 'button' : null}
      aria-expanded={ariaExpanded}
    >
      {children}
    </button>
  );
}
